<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ форматов в приложениях Xiaomi</div>
    <div class="markup__h markup__h_4">
      Платформа Xiaomi Ads имеет несколько форматов размещения.
    </div>
    <div class="attention attention_info">
      <div class="attention__title">Важно знать: </div>
      <p>Все размещения происходят в предустановленных приложениях Xiaomi: GetApps, Mi Browser, Theme, Mi Video, Mi Music, Locking Screen, -1Screen</p>
    </div>
    <br>
    <br>
    <div class="markup__h markup__h_2">
      <strong>Icon</strong>
    </div>
    <div class="markup__h markup__h_4">Иконка приложения в списке «Популярное» приложения GetApps с пометкой «Реклама»</div>
    <br>
    <div class="markup__h markup__h_3">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Изображение с разрешением 84x84 в формате JPG, JPEG или PNG (Размер изображение не более 100 Кб)</li>
      <li>Текст заголовка до 30 символов (название продукта/бренда)</li>
      <li>Текст описания до 80 символов (рекомендация – 30-50 символов)</li>
      <li>Ссылка на продвигаемое приложение</li>
    </ul>
    <format-preview type="small" img="formats_preview/xiaomi_icon.jpg">
      <template v-slot:previewText>Пример размещения</template>
    </format-preview>

    <br>
    <br>

    <div class="markup__h markup__h_2">
      <strong>Banner</strong>
    </div>
    <div class="markup__h markup__h_4">Стандартное баннерное размещение в приложениях (поддерживается только статичная картинка)</div>
    <div class="attention attention_info">
      <div class="attention__title">Важно знать: </div>
      <p>В ротацию можно запустить до 5 креативов каждого из форматов.</p>
    </div>
    <div class="markup__h markup__h_3">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Изображения с разрешением 640x100, 600x500 в формате JPG, JPEG или PNG. Размер изображений не более 500 Кб</li>
      <li>Изображение с разрешением 180x180 в формате JPG, JPEG или PNG. Размер изображения не более 100 Кб</li>
      <li>Текст описания до 40 символов</li>
      <li>Ссылка на посадочную страницу обязательна</li>
    </ul>

    <br>
    <br>

    <div class="markup__h markup__h_2">
      <strong>Large newsfeed image + Icon</strong>
    </div>
    <div class="markup__h markup__h_4">Нативное размещение в лентах приложений, состоящее из изображения, иконки приложения и кнопки с призывом к действию.</div>
    <div class="attention attention_info">
      <div class="attention__title">Важно знать: </div>
      <p>В ротацию можно запустить до 10 изображений. <br> Количество текстов описания и текстов для кнопок в ротации – не более 3-х.</p>
    </div>
    <div class="markup__h markup__h_3">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Изображение с разрешением 84x84 в формате JPG, JPEG или PNG. Размер изображения не более 100 Кб</li>
      <li>Изображение с разрешением 1200х628 в формате JPG, JPEG или PNG. Размер изображения не более 500 Кб</li>
      <li>Текст заголовка до 30 символов (название продукта/бренда)</li>
      <li>Текст описания до 80 символов (рекомендация – 30-50 символов)</li>
      <li>Текст для кнопки (призыв к действию) до 15 символов. Рекомендация: использовать одно слово, например, "Скачать", "Купить" или "Перейти".</li>
    </ul>
    <div class="html2pdf__page-break"/>

    <format-preview type="small" img="formats_preview/xiaomi_newsfeed_image.jpg">
      <template v-slot:previewText>Пример размещения</template>
    </format-preview>

    <br>
    <br>

    <div class="markup__h markup__h_2">
      <strong>Interstitial Image + Icon</strong>
    </div>
    <div class="markup__h markup__h_4">Полноэкранное размещение, состоящее из изображения, иконки приложения и кнопки с призывом к действию.</div>
    <div class="attention attention_info">
      <div class="attention__title">Важно знать: </div>
      <p>В ротацию можно запустить до 10 изображений. <br> Количество текстов описания и текстов для кнопок в ротации – не более 3-х.</p>
    </div>
    <div class="markup__h markup__h_3">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Изображение с разрешением 84x84 в формате JPG, JPEG или PNG. Размер изображения не более 100 Кб</li>
      <li>Изображение с разрешением 1200х628 в формате JPG, JPEG или PNG</li>
      <li>Текст заголовка до 30 символов (название продукта/бренда)</li>
      <li>Текст описания до 80 символов (рекомендация – 30-50 символов)</li>
      <li>Текст для кнопки (призыв к действию) до 15 символов. Рекомендация: использовать одно слово, например, "Скачать", "Купить" или "Перейти".</li>
    </ul>

    <br>
    <br>
    <div class="html2pdf__page-break"/>

    <div class="markup__h markup__h_2">
      <strong>Interstitial video + Icon</strong>
    </div>
    <div class="markup__h markup__h_4">Полноэкранное размещение, состоящее из видео, иконки приложения и кнопки с призывом к действию.</div>
    <div class="attention attention_info">
      <div class="attention__title">Важно знать: </div>
      <p>В ротацию можно запустить до 5 видео креативов. <br> Количество текстов описания и текстов для кнопок в ротации – не более 3-х.</p>
    </div>
    <div class="markup__h markup__h_3">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Изображение с разрешением 84x84 в формате JPG, JPEG или PNG. Размер изображения не более 100 Кб</li>
      <li>Видеофайл в формате MP4 размером не более 10Мб и продолжительностью не более 30 секунд</li>
      <li>Текст заголовка до 30 символов (название продукта/бренда)</li>
      <li>Текст описания до 80 символов (рекомендация – 30-50 символов)</li>
      <li>Текст для кнопки (призыв к действию) до 15 символов. Рекомендация: использовать одно слово, например, "Скачать", "Купить" или "Перейти".</li>
    </ul>

    <br>
    <br>

    <div class="markup__h markup__h_2">
      <strong>Newsfeed video + Icon</strong>
    </div>
    <div class="markup__h markup__h_4">Нативное размещение в лентах приложений, состоящее из видео, иконки приложения и кнопки с призывом к действию.</div>
    <div class="attention attention_info">
      <div class="attention__title">Важно знать: </div>
      <p>В ротацию можно запустить до 5 видео креативов. <br> Количество текстов описания и текстов для кнопок в ротации – не более 3-х.</p>
    </div>
    <div class="markup__h markup__h_3">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Изображение с разрешением 84x84 в формате JPG, JPEG или PNG. Размер изображения не более 100 Кб</li>
      <li>Видеофайл в формате MP4 размером не более 10Мб и продолжительностью не более 30 секунд</li>
      <li>Текст заголовка до 30 символов (название продукта/бренда)</li>
      <li>Текст описания до 80 символов (рекомендация – 30-50 символов)</li>
      <li>Текст для кнопки (призыв к действию) до 15 символов. Рекомендация: использовать одно слово, например, "Скачать", "Купить" или "Перейти".</li>
    </ul>

    <div class="html2pdf__page-break"/>

    <format-preview type="small" img="formats_preview/xiaomi_newsfeed_video.jpg">
      <template v-slot:previewText>Пример размещения</template>
    </format-preview>

  </div>
</template>

<script>
import formatPreview from '@/components/documentation/formatPreview.vue';

export default {
  name: 'xiaomiAds',
  components: {
    formatPreview,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/darcula.min.css'
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
